import { useRecordContext } from 'react-admin';

export const PhoneField = (props) => {
    const record = useRecordContext(props);
    return record ? <span>{record.contactPhoneCountryPrefix || record.prefix}-{record.contactPhone}</span> : null;
}
